export const CREATE_ORGANIZATION = 'createOrganization';
